<template>
  <div>
    <div class="text-center">
      <img class="council_logo" :src="logo" :alt="authority"/>
    </div>
    <b-row>
      <b-col sm="12" md="4">
        <b-card 
          class="text-center" 
          :header="statistics.amount_saved | currency"
          header-class="text-lg-bold"
          :sub-title="`Estimated amount saved in ${authority}`"/>
      </b-col>
      <b-col sm="12" md="4">
        <b-card 
          class="text-center" 
          :header="statistics.resolved | commas" 
          header-class="text-lg-bold"
          :sub-title="`Resolved irregularities in ${authority}`"/>
      </b-col>
      <b-col sm="12" md="4">
        <b-card 
          class="text-center" 
          :header="statistics.investigation_count | commas" 
          header-class="text-lg-bold"
          :sub-title="`On-going Investigations in ${authority}`"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card 
          class="text-center"
          :header="statistics.total_saved | currency"
          header-class="text-lg-bold"
          sub-title="Total saved across all authorities">
          <b-link :to="{name: 'support-month-comparison'}" class="card-link">Extract status</b-link>
          <b-link :to="{name: 'stats-county'}" class="card-link">County-wide stats</b-link>
          <b-link :to="{name: 'stats-by-rule'}" class="card-link text-danger">Rule-based stats</b-link>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['statistics'],
  computed: {
    ...mapGetters([
      'oidcUser',
    ]),
    authority() {
      return this.$authority(this.oidcUser);
    },
    logo() {
      return require(`../assets/logos/${this.authority}.jpg`);
    }
  },
};
</script>

<style type="css">
.card {
  margin-bottom: 10px;
}
.bg-dark .text-muted {
  color: #bdf !important;
}
img.council_logo {
  max-height: 120px;
  margin: 50px;
}
</style>
